module.exports = __webpack_public_path__ + "img/Z60Q_02.9eac2e0b.jpg";